import { UiTableSpinner } from './ui-table-spinner/ui-spinner';
import { UiTableMultirowSpinner } from './ui-table-multirow-spinner/ui-spinner';
import { UiSpinner } from './ui-spinner/ui-spinner';
// import { UiAccordionGroup } from './ui-accordion-group/ui-accordion-group';
import { UiFormGroup } from './ui-form-group/ui-form-group';
import { UiFormElement } from './ui-form-element/ui-form-element';
import { UiText } from './ui-text/ui-text';
import { FeText } from './form-elements/fe-text/fe-text';
import { UiCheckbox } from './ui-checkbox/ui-checkbox';
import { FeCheckbox } from './form-elements/fe-checkbox/fe-checkbox';
import { UiRadio } from './ui-radio/ui-radio';
import { FeRadio } from './form-elements/fe-radio/fe-radio';
import { FeRadioGroup } from './form-elements/fe-radio-group/fe-radio-group';
import { UiButton } from './ui-button/ui-button';
import { FeButton } from './form-elements/fe-button/fe-button';
import { UiSelect } from './ui-select/ui-select';
import { UiSimpleSelect } from './ui-select/ui-simple-select';
import { FeSelect } from './form-elements/fe-select/fe-select';
import { UiMessageBlock } from './ui-message-block/ui-message-block';
import { FeSwitcher } from './form-elements/fe-switcher/fe-switcher';
import { UiLabel } from './ui-label/ui-label';
import { UiSwitcher } from './ui-switcher/ui-switcher';
import { UiHeader } from './ui-header/ui-header';
import { UiListBox } from './ui-list-box/ui-list-box';
import { UiTextArea } from './ui-textarea/ui-textarea';
import { UiLogBox } from './ui-log-box/ui-log-box';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonPipes } from '../pipes';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { TooltipModule, BsDropdownModule } from 'ngx-bootstrap';
import { NavigationComponent } from './ui-navigation/navigation.component';
import { NewsComponent } from './ui-news/news.component';


const uiElements = [
        UiTableSpinner,
        UiTableMultirowSpinner,
        UiSpinner,
        // UiAccordionGroup,
        UiFormGroup,
        UiFormElement,
        UiText,
        UiCheckbox,
        UiRadio,
        UiButton,
        UiSelect,
        UiSimpleSelect,
        UiMessageBlock,
        UiLabel,
        UiSwitcher,
        UiHeader,
        UiListBox,
        UiLogBox,
        UiTextArea,
        NavigationComponent,
        NewsComponent,
];

const formElements = [
        FeText,
        FeCheckbox,
        FeRadio,
        FeRadioGroup,
        FeButton,
        FeSelect,
        FeSwitcher,
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TooltipModule.forRoot(),
        BsDropdownModule.forRoot(),
        CommonPipes,
        TranslateModule
    ],
    declarations: [
        ...uiElements,
        ...formElements,
    ],
    exports: [
        ...uiElements,
        ...formElements
    ]})
export class ComponentModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/index.ts